(() => {
  if (window.blossomRetailCards) return;
  window.blossomRetailCards = true;
  // No buyer identity is supplied. Public Storefront queries remain retail,
  // even when the page is viewed by a signed-in company customer.
  const query = `query RetailCards($ids:[ID!]!,$country:CountryCode!) @inContext(country:$country) {
    nodes(ids:$ids) { ... on ProductVariant { id price { amount currencyCode } } }
  }`;
  async function load(section) {
    if (section.dataset.retailLoaded) return;
    section.dataset.retailLoaded = 'loading';
    const cards = [...section.querySelectorAll('[data-variant-id]')];
    if (!cards.length) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const headers = {'Content-Type':'application/json'};
      // Reuse Shopify's existing public storefront token, when supplied by the theme.
      // No Admin API or customer tokens are used or stored.
      const features = document.getElementById('shopify-features');
      const token = features ? JSON.parse(features.textContent).accessToken : null;
      if (token) headers['X-Shopify-Storefront-Access-Token'] = token;
      const response = await fetch('/api/2026-01/graphql.json', {
        method:'POST', credentials:'same-origin', headers, signal:controller.signal,
        body:JSON.stringify({query,variables:{ids:cards.map(c=>`gid://shopify/ProductVariant/${c.dataset.variantId}`),country:section.dataset.country}})
      });
      const result = await response.json();
      if (!response.ok || result.errors || !Array.isArray(result.data?.nodes)) throw new Error(result.errors?.map(e=>e.message).join('; ') || `HTTP ${response.status}`);
      const prices = new Map(result.data.nodes.filter(Boolean).map(v=>[v.id.split('/').pop(),v.price]));
      for (const card of cards) {
        const price = prices.get(card.dataset.variantId), output = card.querySelector('[data-retail-price]');
        if (!price || price.currencyCode !== section.dataset.currency) { output.textContent=''; continue; }
        const amount = Number(price.amount) * Number(section.dataset.vat);
        output.textContent = Number.isFinite(amount) && amount > 0
          ? `${new Intl.NumberFormat(section.dataset.locale,{style:'currency',currency:price.currencyCode}).format(amount)} ${price.currencyCode} ${section.dataset.taxLabel}` : '';
      }
      section.dataset.retailLoaded = 'ready';
    } catch (error) {
      // Keep the server-rendered public price for guests. Trade contexts never
      // get a server-rendered catalogue price as a misleading retail fallback.
      section.dataset.retailLoaded = 'unavailable';
      section.dataset.retailError = error.message;
    } finally { clearTimeout(timeout); }
  }
  function init(root=document) {
    for (const section of root.querySelectorAll('[data-blossom-cards]')) {
      if (section.dataset.observed) continue;
      section.dataset.observed='true';
      if (!('IntersectionObserver' in window)) {load(section);continue;}
      const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();load(section);}},{rootMargin:'600px'});
      observer.observe(section);
    }
  }
  init();document.addEventListener('shopify:section:load',()=>init());
})();
